<template>
  <div class="agenda-grid-item" @click="selectDate"
       v-bind:class="{ selected: agendaDate.selected, today: isToday }">
    <div class="wrapper">
      <div class="dateText">{{ agendaDate.date.getDate() }}</div>
      <div class="activity-pips">
        <div class="activity-pip"
             v-for="activityPip in visibleActivityPips"
             v-bind:key=activityPip.id
             v-bind:activityPip=activityPip

             :style="{backgroundColor: activityPip.color}"
             :class="activityPip.lastPip? 'last-pip' : ''"
        >
          <i class="plus-icon fas fa-plus"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateComparison from "@/mixins/DateComparison";

export default {
  name: "AgendaGridItem",
  mixins: [ DateComparison ],
  props: {
    agendaDate: Object
  },
  data()
  {
    return {
      selected: false
    }
  },
  computed: {
    visibleActivityPips()
    {
      let allPips = this.agendaDate.activityPips;
      let visiblePips = [];
      for (let i = 0; i < allPips.length; i++)
      {
        if (i < 3) {
          allPips[i].lastPip = false;
          visiblePips.push(allPips[i]);
        } else if (i === 3) {
          allPips[i].lastPip = true;
          visiblePips.push(allPips[i]);
        }
      }

      return visiblePips;
    },

    setPipColor(activityPip)
    {
      return ("background-color:" + activityPip.color)
    },

    todayDate()
    {
      return new Date();
    },
    isToday()
    {
      return this.isSameDay(this.agendaDate.date, this.todayDate);
    }
  },
  methods: {
    selectDate()
    {
      this.$emit("dateClicked", this.agendaDate.date);
    },
    setSelected()
    {
      this.selected = true;
    }
  },
  created()
  {

  }
}
</script>

<style lang="scss" scoped>
.agenda-grid-item
{
  border-radius: 5px;
  display: flex;
  width: 100%;
  height: 100%;
  cursor: pointer;

  border: 2px solid transparent;

  &.selected
  {
    background-color: $primary-blue;
    color: white;
  }

  &.today
  {
    border-color: $primary-blue;
  }

  .wrapper
  {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    padding: 5%;
  }

  .dateText
  {
    display: flex;
    flex-grow: 2;
    justify-content: center;
    align-content: center;
    font-size: 1rem;
  }

  .activity-pips
  {
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    justify-content: space-evenly;
    align-content: center;
  }

  .activity-pip
  {
    width: 6px;
    height: 6px;
    background-color: red;
    border-radius: 5px;

    .plus-icon
    {
      display: none;
    }
  }

  .last-pip
  {
    background-color: transparent !important;

    .plus-icon
    {
      display: block;
      font-size: 6px;
      color: $font-grey;
    }
  }
}

//small hack to force square responsive grid items
.agenda-grid-item:before
{
  content: "";
  display: block;
  height: 0;
  width: 0;
  padding-bottom: 100%;
}
</style>